module.exports = __webpack_public_path__ + "static/media/schedule_structure_add_a_day.87f42396.mov";